import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faClock, faFlagCheckered, faPlay, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardName from "../../../../components/global/CardName";
import { listClear as clearWidget } from '../../../../reducers/models/widgetData';
import Widget from "../../../../components/card/widget/Widget";
import CardProjectChange from "../../../../components/card/project/CardProject";
import CardTimetable from "./CardTimetable";
import SrvButton from "../../../../components/global/SrvButton";
import { Form } from "react-bootstrap";
import StringToInputDate from "../../../../util/StringToInputDate";
import FilterDate from "../../../../components/filter/FilterDate";
import StringToDateTime from "../../../../util/StringToDateTime";
import WidgetModalAdd from "../../../../components/card/widget/WidgetAddModal";
import CardUser from "../../../../components/card/CardUser";
import DateStartEndHistory from "./DateStartEndHistory";
import WidgetAddFavorite from "../../../../components/card/widget/WidgetAddFavorite";
import axios from "axios";
import TabBarCard from "../../../../components/ui/TabBarCard";
import ButtonAction from "../../../../components/global/ButtonAction";
import WidgetItemPriority from "../../../../components/card/widget/WidgetItemPriority";
import WidgetItemLabel from "../../../../components/card/widget/WidgetItemLabel";
import ErrorAdd from "../../../../util/ErrorAdd";

function ModalUpdate({ show, onHide, /*model,*/ calendar, idTask }) {

    /* 
    calendar - true/false
    */
    const id_object = 2;

    const dispatch = useDispatch();

    const stateSize = useSelector((state) => state.size);//Размеры окна
    const stateWidgetData = useSelector((state) => state.widgetData);//Данные для виджета
    const stateList = useSelector((state) => state.taskRlist);//Редюсер задач

    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки

    const [hightBody, setHightBody] = useState(0);

    //TAB START
    const tab = [
        { id_tab: 0, name: "Основное", icon: faPlay, showCount: false }
        , { id_tab: 1, name: "История", icon: faArchive, showCount: false }
    ];
    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(0);

    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 1) {
            if (idTask !== null) {
                axios.get('/api_tracker/taskR/trackerListCompletedByTask', { params: { ID_TaskR: idTask, Date_Start: completedDateStart, Date_End: completedDateEnd } })
                    .then((res) => {
                        setCompletedData(res.data.Data);
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
    }
    //TAB END


    const [log, setLog] = useState(null);
    const [logWidget, setLogWidget] = useState(null);

    const [loading, setLoading] = useState(false);

    const [widgetModalShow, setWidgetModalShow] = useState(false);
    const [widgetEditing, setWidgetEditing] = useState(false);

    //const [idTask, setIdTask] = useState(null);
    const [formArchive, setFormArchive] = useState(false);
    const [formName, setFormName] = useState(null);
    const [formIdType, setFormIdType] = useState(1);//Выполнят один из ответственных
    const [formIdProject, setFormIdProject] = useState(null);

    useEffect(() => {
        if (refHeader.current !== undefined & refFooter.current !== undefined & stateSize.desktop !== true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 115)
        }
        if (refHeader.current !== undefined & stateSize.desktop === true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 120)
        }
    }, [refHeader, refFooter, stateSize, /*formName, loadingUser,*/ stateWidgetData.list]);

    useEffect(() => {

        if (stateList.list.filter(a => a.ID === idTask).length > 0) {
            const model = stateList.list.filter(a => a.ID === idTask)[0];

            setFormName(model.Name);
            setFormIdType(model.ID_Type);
            setFormIdProject(model.ID_Project);
            setFormArchive(model.Archive);

            //Сегдняшний день
            let newDate = new Date()
            setFormTaskAddDateStart(StringToInputDate(newDate));
        }

    }, [idTask, stateList.list]);

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);

    //Добавит/Обновит задачу
    function updateName(name) {
        setLoadingName(true);
        setLogName(null);

        if (name === null) {
            setLogName('Введите название доски');
            setLoadingName(false);
        }
        else {
            axios.post('/api_tracker/taskR/updateName', { ID_TaskR: idTask, Name: name })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setHideName(true);
                        setLoadingName(false);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoadingName(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoadingName(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    //Обновит тип задачи
    function updateTypeHandler(idType) {
        setLoading(true);

        axios.post('/api_tracker/taskR/updateType', { ID_TaskR: idTask, ID_Type: idType })
            .then((res) => {
                if (res.data.Status === 1) {

                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    /*****************************START АРХИВИРОВАНИЕ*******************************/
    const [modalArchiveShow, setModalArchiveShow] = useState(false);
    const [modalArchiveCancelShow, setModalArchiveCancelShow] = useState(false);
    const [logArchive, setLogArhive] = useState(null);
    const [loadingArchive, setLoadingArchive] = useState(false);

    function arhiveHandler() {
        setLoadingArchive(true);
        axios.post('/api_tracker/taskR/archive', { ID_TaskR: idTask })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalArchiveShow(false);
                    onHide();
                }
                else {
                    setLogArhive(res.data.Error);
                    setLoadingArchive(false);
                }
            })
            .catch((err) => {
                setLogArhive('Неизвестная ошибка!');
                setLoadingArchive(false);
                ErrorAdd(err, window.location.href);
            });

    }
    function arhiveCancelHandler() {
        setLoadingArchive(true);
        axios.post('/api_tracker/taskR/archiveCancel', { ID_TaskR: idTask })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalArchiveCancelShow(false);
                    onHide();
                }
                else {
                    setLogArhive(res.data.Error);
                    setLoadingArchive(false);
                }
            })
            .catch((err) => {
                setLogArhive('Неизвестная ошибка!');
                setLoadingArchive(false);
                ErrorAdd(err, window.location.href);
            });
    }

    /******************************END АРХИВИРОВАНИЕ********************************/
    /*************************START СОЗДАНИЕ БЕЗ РАСПИСАНИЯ*************************/
    const [modalTaskAddShow, setModalTaskAddShow] = useState(false);
    const [logTaskAdd, setLogTaskAdd] = useState(null);
    const [loadingTaskAdd, setLoadingTaskAdd] = useState(false);
    const [formTaskAddDateStart, setFormTaskAddDateStart] = useState(null);
    const [formTaskAddDateEnd, setFormTaskAddDateEnd] = useState(null);

    function taskAddHandler() {
        setLoadingTaskAdd(true);
        if (formTaskAddDateStart === null || formTaskAddDateStart === '' || formTaskAddDateStart === undefined) {
            setLogTaskAdd('Введите дату начала');
            setLoadingTaskAdd(false);
        }
        else {

        }
        axios.post('/api_tracker/taskR/trackerAddManually', { ID_TaskR: idTask, Date_Start: formTaskAddDateStart, Date_End: formTaskAddDateEnd })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalTaskAddShow(false);
                    onHide();
                }
                else {
                    setLogTaskAdd(res.data.Error);
                    setLoadingTaskAdd(false);
                }
            })
            .catch((err) => {
                setLogTaskAdd('Неизвестная ошибка!');
                setLoadingTaskAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /**************************END СОЗДАНИЕ БЕЗ РАСПИСАНИЯ**************************/
    /***************************START ИСТОРИЯ ВЫПОЛНЕНИЯ****************************/
    const [completedDateStart, setCompletedDateStart] = useState(null);
    const [completedDateEnd, setCompletedDateEnd] = useState(null);
    const [completedData, setCompletedData] = useState([]);

    //Клик по вкладке "Выполненные"
    function completedTabHandler() {
        if (idTask !== null) {
            axios.get('/api_tracker/taskR/trackerListCompletedByTask', { params: { ID_TaskR: idTask, Date_Start: completedDateStart, Date_End: completedDateEnd } })
                .then((res) => {
                    setCompletedData(res.data.Data);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    //Изменение даты
    function completedDateHandler(date_start, date_end) {
        setCompletedDateStart(date_start);
        setCompletedDateEnd(date_end);

        if (tabSelected === 1) {
            axios.get('/api_tracker/taskR/trackerListCompletedByTask', { params: { ID_TaskR: idTask, Date_Start: date_start, Date_End: date_end } })
                .then((res) => {
                    setCompletedData(res.data.Data);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    /****************************END ИСТОРИЯ ВЫПОЛНЕНИЯ*****************************/
    /********************************START ПРОЕКТ***********************************/
    const [logProject, setLogProject] = useState(null);
    const [loadingProject, setLoadingProject] = useState(null);
    const [hideModalProject, setHideModalProject] = useState(false);

    function updateProjectHandler(idProject) {
        setLoadingProject(true);
        setHideModalProject(false);

        axios.post('/api_tracker/taskR/projectSet', { ID_TaskR: idTask, ID_Project: idProject })
            .then((res) => {
                if (res.data.Status === 1) {
                    //setFormIdProject(id);
                    setHideModalProject(true);
                    setLoadingProject(false);
                }
                else {
                    setLogProject(res.data.Error);
                    setLoadingProject(false);
                }
            })
            .catch((err) => {
                setLogProject('Неизвестная ошибка!');
                setLoadingProject(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /*********************************END ПРОЕКТ************************************/
    const [addedWidget, setAddedWidjet] = useState(null);
    function widgetAddHandler(idWidget) {
        setAddedWidjet(idWidget);
    }
    function widgetMenuHandler(id_menu) {
        //id_menu: 1-Добавление; 2-Редактирование
        if (id_menu === 1) {
            setWidgetModalShow(true);
        }
        if (id_menu === 2) {
            setWidgetEditing(!widgetEditing)
        }
    }

    function eventModalClose() {
        onHide();
        //ОЧИЩАЕМ ФОРМУ          
        // setFormName(null);
        setLoading(false);
        setLog(null);
        setLog(null);
        setLogWidget(null);
        dispatch(clearWidget());//Очищаем виджеты*/
    }

    return (
        <>
            {widgetModalShow === true && (
                <WidgetModalAdd id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} />
            )}
            {modalArchiveShow === true && (
                <Modal show={modalArchiveShow} onHide={() => setModalArchiveShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-15">Архивирование задачи</div>
                        <div className="mt-15 text-center">Подтвердите архивирование задачи <b>«{formName}»</b></div>
                        {logArchive !== null && <div className="form_error text-center mt-15">{logArchive}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="archive" size='lg' loading={loadingArchive} onClick={() => arhiveHandler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}
            {modalArchiveCancelShow === true && (
                <Modal show={modalArchiveCancelShow} onHide={() => setModalArchiveCancelShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-15">Отмена архивирование задачи</div>
                        <div className="mt-15 text-center">Подтвердите отмену архивирование задачи <b>«{formName}»</b></div>
                        {logArchive !== null && <div className="form_error text-center mt-15">{logArchive}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="cancel" size='lg' loading={loadingArchive} onClick={() => arhiveCancelHandler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}
            {modalTaskAddShow === true && (
                <Modal show={modalTaskAddShow} onHide={() => setModalTaskAddShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-15">Отправка задачи пользователям</div>
                        <div className="mt-15 text-center">Задачи будут отправлены указанным ответственным без расписания (сразу)</div>
                        <div className="row mt-15">
                            <div className="col-md-6">
                                <Form.Label>Дата начала</Form.Label>
                                <Form.Control type="date" onChange={(e) => setFormTaskAddDateStart(e.target.value)} defaultValue={formTaskAddDateStart}
                                />
                            </div>
                            <div className="col-md-6">
                                <Form.Label >Дата завершения</Form.Label>
                                <Form.Control type="date" onChange={(e) => setFormTaskAddDateEnd(e.target.value)} defaultValue={formTaskAddDateEnd}
                                />
                                <small>(Не обязательно)</small>
                            </div>
                        </div>
                        {logTaskAdd !== null && <div className="form_error text-center mt-15">{logTaskAdd}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="send" size='lg' loading={loadingTaskAdd} onClick={() => taskAddHandler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}
            <Modal show={show} onHide={() => eventModalClose()} size="lg">
                <Modal.Body >
                    {calendar === false && (
                        <div className="mb-5" style={{ display: 'flex' }}>
                            <div>
                                <TabBarCard tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} />
                            </div>
                            <div style={{ marginLeft: 'auto' }} className="modal_close" onClick={() => eventModalClose()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        </div>
                    )}
                    <div className={tabSelected === 0 ? "d-block" : "d-none"} role="tabpanel">
                        {stateSize.desktop === true ? (
                            <div className="row" >
                                <div className="col-md-8" >
                                    <div ref={refHeader}>
                                        <div>
                                            <CardName name={formName} updateHandler={updateName} onlyRead={calendar} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div>
                                                <CardProjectChange idTask={idTask} idProject={formIdProject} idObject={id_object} idSelected={formIdProject} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={calendar} />
                                            </div>
                                            <div style={{ marginLeft: 'auto' }}>
                                                {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                                    <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={idTask} onlyRead={calendar} added={addedWidget} />
                                                )}
                                            </div>
                                        </div>
                                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                            <WidgetItemLabel idTab={calendar === true ? -1 : tabSelected} idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={idTask} onlyRead={calendar} added={addedWidget} />)}

                                    </div>
                                    <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody, overflow: 'auto' }}>
                                        <Widget idObject={id_object} idItem={idTask} editMode={widgetEditing} idProject={formIdProject} onlyRead={calendar} addedWidget={addedWidget} idTab={calendar === true ? -1 : tabSelected} />
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 120, overflow: 'auto' }}>
                                    {calendar === false && (
                                        <>
                                            <div className="card-block-title">Действия</div>
                                            {formArchive === true ? (

                                                <div><ButtonAction typeBtn='cancel' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                            ) : (
                                                <>
                                                    <div><ButtonAction typeBtn='send' textBtn='Отправить пользователям' onClick={() => setModalTaskAddShow(true)} /></div>
                                                    <div className="mt-5"><ButtonAction typeBtn='archive' textBtn='В архив' onClick={() => setModalArchiveShow(true)} /></div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {formArchive === false && (
                                        <>
                                            <div className="card-block-title">Ответственные</div>
                                            <CardUser idItem={idTask} idObject={id_object} idType={formIdType} typeChangeHandler={updateTypeHandler} idProject={formIdProject} onlyRead={calendar} />

                                            {calendar === false && (
                                                <>
                                                    <div className="card-block-title">Расписание</div>
                                                    <CardTimetable idTask={idTask} idObject={id_object} onlyRead={false} />
                                                    <WidgetAddFavorite id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <>
                                <div ref={refHeader}>
                                    <CardName name={formName} updateHandler={updateName} onlyRead={calendar} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div>
                                            <CardProjectChange idTask={idTask} idProject={formIdProject} idObject={id_object} idSelected={formIdProject} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={calendar} />
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                                <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={idTask} onlyRead={calendar} added={addedWidget} />
                                            )}
                                        </div>
                                    </div>
                                    {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                        <WidgetItemLabel idTab={calendar === true ? -1 : tabSelected} idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={idTask} onlyRead={calendar} added={addedWidget} />)}
                                </div>
                                <div key={hightBody} style={{ maxHeight: hightBody, overflow: 'auto' }}>
                                    <Widget idObject={id_object} idItem={idTask} editMode={widgetEditing} idProject={formIdProject} onlyRead={calendar} addedWidget={addedWidget} />
                                </div>
                                <div ref={refFooter}>
                                    <hr></hr>
                                    <CardUser idItem={idTask} idObject={id_object} idType={formIdType} typeChangeHandler={updateTypeHandler} idProject={formIdProject} onlyRead={calendar} />
                                    <hr></hr>
                                    {formArchive === false && (
                                        calendar == false &&
                                        <>
                                            <CardTimetable idTask={idTask} onlyRead={false} />
                                            <hr></hr>
                                        </>
                                    )}
                                    {calendar === false && (
                                        <div className="m_btn_block_footer" style={{ height: '55px' }}>
                                            {formArchive === true ? (
                                                <div><ButtonAction typeBtn='cancel' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                            ) : (
                                                <>
                                                    <div><ButtonAction typeBtn='send' onClick={() => setModalTaskAddShow(true)} /></div>
                                                    <div><ButtonAction typeBtn='archive' textBtn='В архив' onClick={() => setModalArchiveShow(true)} /></div>
                                                    <WidgetAddFavorite id={idTask} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                    <div className={tabSelected === 1 ? "d-block" : "d-none"} role="tabpanel">
                        <div>
                            <FilterDate defaultVal={4} changHandler={completedDateHandler} />
                        </div>
                        <div style={stateSize.desktop === true ? { minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 170, overflow: 'auto' } : { minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 200, overflow: 'auto' }}>
                            {completedData.map((item) => (
                                <div key={item.ID} className={"list_item mt-10"} >
                                    <div className="col-md-6">
                                        <FontAwesomeIcon fontSize={'15px'} icon={faFlagCheckered} className="mr-10" />
                                        {StringToDateTime(item.Completed_Date)}
                                    </div>
                                    <div className="col-md-6 te" >
                                        <div className="ms-md-auto" style={{ width: '220px' }}>
                                            <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{item.Timetable_String === null ? "Вручную" : item.Timetable_String}</div>
                                            {<small><DateStartEndHistory date_start={item.Date} date_end={item.Date_Finish} date_completed={item.Completed_Date} /></small>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                </Modal.Body>
            </Modal >


        </>
    );
}
export default ModalUpdate;
